import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { PopoverRef } from '../popover/popover-ref';

@Component({
  selector: 'vex-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss']
})
export class UserMenuComponent implements OnInit {

  constructor(private readonly popoverRef: PopoverRef, private router: Router) { }

  ngOnInit(): void {
  }

  close(): void {
    /** Wait for animation to complete and then close */
    setTimeout(() => this.popoverRef.close(), 250);

    localStorage.clear();
    this.router.navigateByUrl('/login');
  }

  cerrarSesion(){
    localStorage.clear();
    this.router.navigateByUrl('/login');
  }
}
